import React from 'react';
import Joi from '@hapi/joi';
import { Container, Divider, Grid, Paper, Typography } from '@material-ui/core';
import { withSnackbar } from 'notistack';

import Breadcrumb from '../common/breadcum';
import Form from '../common/form';
import { getEspochUser } from '../../services/espochUserService';
import { getUser, saveUser } from '../../services/userService';
import { isNumeric } from '../../utils/helperFunctions';
import { levels, SEX } from '../../utils/constants';
import Loading from '../common/loading';
import { notifications } from '../../utils/messages';
import { messages } from '../common/es_ES';
import SearchBox from '../user/components/SearchBox';

class ResearcherForm extends Form {
  state = {
    data: {
      belongs_espoch: 'Sí',
      identification_card: '',
      email: '',
      name: '',
      lastname: '',
      fullname: '',
      level: levels.NO_ASIGNADO,
      sex: '',
      roles: [],
      permissions: [],
    },
    search: '',
    errors: {},
    isLoading: false,
  };

  schema = Joi.object({
    id: Joi.string(),
    belongs_espoch: Joi.string()
      .label('Usuario ESPOCH')
      .max(2)
      .messages(messages),
    identification_card: Joi.string()
      .label('Cédula')
      .min(10)
      .max(10)
      .messages(messages),
    name: Joi.string().label('Nombre').max(100).messages(messages),
    lastname: Joi.string().label('Apellido').max(100).messages(messages),
    fullname: Joi.string().allow('').label('Nombre Completo').max(100),
    email: Joi.string()
      .email({
        minDomainSegments: 2,
        tlds: { allow: ['com', 'espoch', 'edu', 'ec', 'org'] },
      })
      .label('Correo')
      .max(100)
      .messages(messages),
    level: Joi.string().label('Nivel').max(11).messages(messages),
    sex: Joi.string().label('Sexo').max(10).messages(messages),
    roles: Joi.array().label('Roles').allow('').messages(messages),
    permissions: Joi.array().label('Permisos').allow('').messages(messages),
  });

  async populateUser() {
    try {
      const userId = this.props.match.params.id;
      if (userId === 'new' || userId === 'se') return; //Si si
      const { data: user } = await getUser(userId); //Si no.
      this.setState({ data: this.mapToViewModel(user) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace('/not-found');
    }
  }
  mapToViewModel(user) {
    return {
      id: user.id,
      belongs_espoch: user.belongs_espoch === 1 ? 'Sí' : 'No',
      identification_card:
        user.identification_card === null ? '' : user.identification_card,
      name: user.name,
      lastname: user.lastname,
      fullname: user.fullname,
      level: user.level,
      sex: user.sex,
      email: user.email,
      roles: user.roles,
    };
  }

  handleChangeSearch = ({ target }) => {
    const value = target.value.trim();
    this.setState({ search: value });
  };

  handleSearch = async () => {
    try {
      this.setState({ isLoading: true, errors: {} });
      const { data: espochUser } = await getEspochUser(this.state.search);
      if (Object.keys(espochUser).length && espochUser.per_email !== null) {
        const data = { ...this.state.data };
        if (isNumeric(this.state.search)) {
          data['identification_card'] = this.state.search;
        } else {
          data['identification_card'] = '';
        }
        data['name'] = espochUser.per_nombres;
        data['lastname'] =
          espochUser.per_primerApellido + ' ' + espochUser.per_segundoApellido;
        data['email'] = espochUser.per_email;
        data['sex'] = espochUser.sex_id === 1 ? 'Hombre' : 'Mujer';
        this.setState({ data });
      } else {
        this.props.enqueueSnackbar(notifications.NOT_FOUND_USER, {
          variant: 'error',
        });
      }
    } catch (error) {
      console.error(error);
      this.props.enqueueSnackbar(error.response, {
        variant: 'error',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  doSubmit = async () => {
    try {
      this.setState({ isLoading: true });
      const data = { ...this.state.data };
      data['belongs_espoch'] = data['belongs_espoch'] === 'Sí' ? true : false;
      await saveUser(data);
      this.successMessage();
      if (this.props.match.params.id !== 'se') {
        this.props.history.push('/investigadores');
      }
      this.setState({ isLoading: false });
    } catch (ex) {
      this.setState({ isLoading: false });
      if (ex.response && ex.response.status === 422) {
        this.errorMessage(ex);
        const errors = { ...this.state.errors };
        errors.email = ex.response.data.errors.email;
        errors.name = ex.response.data.errors.name;
        errors.lastname = ex.response.data.errors.lastname;
        errors.identification_card =
          ex.response.data.errors.identification_card;
        this.setState({ errors });
      } else {
        this.errorMessage(ex);
      }
    }
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.populateUser();
    this.setState({ isLoading: false });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.match.params.id === 'new') {
      if (this.state.data.belongs_espoch !== prevState.data.belongs_espoch) {
        const data = { ...this.state.data };
        data.identification_card = '';
        data.email = '';
        data.name = '';
        data.lastname = '';
        data.fullname = '';
        data.level = levels.NO_ASIGNADO;
        data.sex = '';
        this.setState({ data, search: '', errors: {} });
      }
    }
  }

  render() {
    const { data, isLoading } = this.state;
    const listBreadcrumbs = [
      {
        path: '/investigadores',
        label: 'Investigadores',
      },
    ];
    const espochOptions = [
      { id: 1, name: 'Sí' },
      { id: 2, name: 'No' },
    ];
    const levelOptions = [
      { id: 1, name: levels.JUNIOR },
      { id: 2, name: levels.SENIOR },
      { id: 3, name: levels.NO_ASIGNADO },
    ];
    const sexOptions = [
      { id: 1, name: SEX.MUJER },
      { id: 2, name: SEX.HOMBRE },
    ];
    const option = data.belongs_espoch === 'Sí' ? true : false;
    const paramsId = this.props.match.params.id;
    return (
      <Container maxWidth='sm' id='userAddForm'>
        <Loading open={isLoading} />
        <Breadcrumb
          onListBreadcrumbs={listBreadcrumbs}
          lastLabel={
            paramsId === 'new' ? 'Agregar investigador' : 'Editar Investigador'
          }
        />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Paper className='paper'>
              <Typography variant='h5' gutterBottom>
                Investigador
              </Typography>
              <Divider />
              <form onSubmit={this.handleSubmit}>
                {this.renderRadio(
                  'belongs_espoch',
                  'Pertenece  a la ESPOCH:',
                  espochOptions,
                  this.props.match.params.id !== 'new'
                )}
                {this.props.match.params.id === 'new' && option && (
                  <SearchBox
                    onHandleChangeSearch={this.handleChangeSearch}
                    onHandleSearch={this.handleSearch}
                    value={this.state.search}
                  />
                )}
                {this.renderInput(
                  'identification_card',
                  'Cédula',
                  'text',
                  option && isNumeric(this.state.search)
                )}
                {this.renderInput('email', 'Correo *', 'text', option)}
                {this.renderInput('name', 'Nombres *', 'text', option)}
                {this.renderInput('lastname', 'Apellidos *', 'text', option)}
                {this.renderRadio('sex', 'Sexo:', sexOptions, option)}
                {this.renderRadio('level', 'Nivel:', levelOptions)}
                {this.renderButton('Guardar investigador')}
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withSnackbar(ResearcherForm);
